<template>
    <div class="errors">
        <div class="error" v-for="msg in messages">{{ }}</div>
        
        
    </div>
</template>
<script>
export default {
    props:{
        messages:{
            type: Array
        }
    }
}
</script>
<style scoped>
    
</style>